import { isDate, isValid } from '@core/date.facade';
import { parseISOWithFallback } from '@core/functions/parse-iso-with-fallback';
import { tryParseDate } from '@shared/functions/try-parse-date';

const SQL_DATETIME_PATTERN = /^\d{4}-\d{2}-\d{2}[ T]\d{2}:\d{2}:\d{2}(\.\d+)?$/;

/**
 * BCM audit timestamps (`insertedOn`, `lastUpdateOn`) are stored as UTC in MariaDB
 * but often arrive as SQL datetime strings without a timezone suffix.
 */
export function parseBcmAuditTimestamp(value: unknown): Date | null {
    if (value == null || value === '') {
        return null;
    }

    if (typeof value === 'string') {
        const trimmed = value.trim();

        if (SQL_DATETIME_PATTERN.test(trimmed) && !/[zZ]|[+-]\d{2}:\d{2}$/.test(trimmed)) {
            const parsedUtc = parseISOWithFallback(`${trimmed.replace(' ', 'T')}Z`, null);

            if (isDate(parsedUtc) && isValid(parsedUtc)) {
                return parsedUtc;
            }
        }
    }

    return tryParseDate(value);
}
